import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Brand from './Brand'

const CreateBrand = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Brand - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
        <Brand />
      </div>
    </div>
  );
};

export default CreateBrand;
